/**
 * @description 底部操作按钮（转赠、减时卡、合成）
*/
import React, { useState, useEffect, useRef, useMemo } from "react";
import {useNavigate} from "react-router";
import { Popup, Toast } from "antd-mobile";
import classNames from "classnames";
import ModalAlert from "@/components/ModalAlert";
import {showLoading, hideLoading} from '@/components/loading';
import ColCompoundHome from "@/view/colCompound/home";
import DonationModal from "@/components/donationModal";
import {getTime} from '@/utils/publicFun';
import ReduceCard from '../reduceCard';
import {
    remainTimeCardUse,
    getHcStatus,
    getRemainTimeCardList,
    getUserCollectionsSetting,
    recoveryActivityExec,
    addShareRecord,
    deleteShareRecord
} from '@/api/projectManager_self';
import './index.scss';

import reduceImg from '@/assets/img/collection/reduce_card.png';
import imgSynthesis from '@/assets/img/img_synthesis.png';

const CodeMap = {
    207: 'healthPreservation', //康养藏品
}

const limitNum = (remainDays) => {
    let limit = 0;
    if (remainDays <= 5) {
        limit = 1;
    } else if (remainDays > 5 && remainDays <= 10) {
        limit = 2;
    } else if (remainDays > 10 && remainDays <= 15) {
        limit = 3;
    } else if (remainDays > 15 && remainDays <= 20) {
        limit = 4;
    } else if (remainDays > 20 && remainDays <= 25) {
        limit = 5;
    } else if (remainDays > 25 && remainDays <= 30) {
        limit = 6;
    }
    return limit;
}

const BeautifulNumBtnText = {
    0: '使用',
    1: '取消使用',
    2: '审核中',
    3: '未通过，重新提交',
  }

/** 去微信分享时的本地标志，用于从微信切回 APP 时判断是否用户取消 */
const WECHAT_SHARE_PENDING_KEY = 'myCollectionDetail_wechatSharePending';

const Footer = (props = {}) => {
    const { 
        nft_hash, detailList, spHeChengInfo={}, hcStatus={}, 
        onUseBeautifulNumBtn, onRefesh, gemsFee, gemsCount,activityCode,benefitList
    } = props;

    const navigate = useNavigate()

    const [modalVisible, setModalVisible] = useState(false);
    const [cardVisible, setCardVisible] = useState(false);
    const [list, setList] = useState([]);
    const [chooseArr, setChooseArr] = useState([]);
    const [reduceDays, setReduceDays] = useState(0);
    const [pwdVisible, setPwdVisible] = useState(false);
    const [cardModalVisible, setCardModalVisible] = useState(false);
    const [colCompHomeVisible, setColCompHomeVisible] = useState(false);
    const [usedDays, setUsedDays] = useState(0);
    const [targetNftNoModalVisible, setTargetNftNoModalVisible] = useState(false);//关联藏品转赠弹窗
    const [blessingModalVisible, setBlessingModalVisible] = useState(false);//祝福语选择弹窗
    const [selectedBlessing, setSelectedBlessing] = useState('马到成功');//选中的祝福语

    // 从微信切回 APP 当前页时，若存在「去微信分享」标志，视为用户已取消
    useEffect(() => {
        const onVisibilityChange = () => {
            if (document.visibilityState !== 'visible') return;
            try {
                const raw = window.localStorage.getItem(WECHAT_SHARE_PENDING_KEY);
                if (!raw) return;
                window.localStorage.removeItem(WECHAT_SHARE_PENDING_KEY);
                const data = JSON.parse(raw);
                const shareRecordId = data?.shareRecordId;
                const createdThisSession = data?.createdThisSession;
                // if (createdThisSession && shareRecordId) {
                //     deleteShareRecord({ shareRecordId }).catch(() => {});
                // }
                // Toast.show('用户已取消');
            } catch (e) {}
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => document.removeEventListener('visibilitychange', onVisibilityChange);
    }, []);

    useEffect(() => {
        let num = 0;
        let limit;
        if (!chooseArr.length) {
            const newList = list?.map((l) => {
                return {...l, isAvailable: false};
            })
            num = 0;
            setReduceDays(num);
            setList(newList);
            return;
        }
        ;
        num = chooseArr.reduce((pre, curr) => {
            return pre += curr.reduceDay;
        }, 0);
        if (Number(list[0]?.accumulateDays) === 30) {
            limit = chooseArr.length === limitNum(detailList?.remainDays);
        } else {
            limit = num === (detailList?.remainDays < (Number(list[0]?.accumulateDays) - Number(usedDays)) ? limitNum(detailList?.remainDays) * list[0]?.reduceDay : (Number(list[0]?.accumulateDays) - Number(usedDays)));
        }
        if (limit) {
            const arr = chooseArr.map((c) => c.timeReduceId)
            const newList = list.map((l) => {
                return {...l, isAvailable: arr.includes(l.timeReduceId) ? false : true};
            })
            setList(newList);
        } else {
            const newList = list?.map((l) => {
                return {...l, isAvailable: false};
            })
            setList(newList);
        }
        setReduceDays(num);
    }, [chooseArr])

    const getReduceTimeCard = async () => {
        try {
            showLoading();
            const params = {
                nftNo: detailList?.nftNo || '',
                collectionId: detailList?.collectionId || '',
            }
            const res = await getRemainTimeCardList(params);
            // const res = await mockCardFn();
            hideLoading();
            if (res.code !== '000000') throw res.msg;
            let newList = [];
            if (res?.data?.timeReduceCardInfoList?.length > 0) {
                newList = res.data.timeReduceCardInfoList.map((item) => {
                    return {
                        ...item,
                        isAvailable: Number(res.data.usedDays) === Number(item.accumulateDays) ? true : false
                    };
                })
            }
            setList(newList);
            setUsedDays(res.data.usedDays || 0);
            setCardVisible(true);
        } catch (error) {
            hideLoading();
            Toast.show(error);
        }
    }

    const hcClick = async () => { //合成
        if (hcStatus.status !== 1) return;
        try {
            showLoading();
            const {code, msg, data} = await getHcStatus({nftHash: nft_hash});
            hideLoading();
            if (code === '000000') {
                if (data && data === 1) {
                    const uri = `/eggHatch?nftNo=${detailList?.nftNo}&collectionGroup=${detailList.collectionGroup}`
                    if(window.JsBridge.hasWebViewBridge()) {
                        window.JsBridge.replace("CustomWeb", {uri: `${window.location.origin}${uri}`});
                    }else {
                        navigate(uri);
                    }
                } else {
                    Toast.show('您当前已孵化合成过,请在我的藏品列表刷新数据查看');
                }
            } else {
                Toast.show(msg);
            }
        } catch (error) {
            hideLoading();
            Toast.show(error);
        }
    }

    // 康养合成
    const onKangyangMerge = ()=> {
        const content = (
            <div style={{padding: '20px 0', textAlign:'center'}}>
                恭喜集齐，合成后将获得 45 平米康养公寓永久使用权，客服将第一时间联系您完成线下签约，确认合成？
            </div>
        )
        ModalAlert.show({
            title: '确认合成',
            content: content,
            onAction: async (btn, index) => {
                if(btn.key === 'confirm') {
                    showLoading();
                    // 调用合成接口
                    const res = await recoveryActivityExec({activityCode: CodeMap[detailList?.collectionId || '']})
                    hideLoading();
                    if(res.code === '000000') {
                        ModalAlert.hide();
                        const list = res.data?.userCollectionRespList ?? [];
                        const collectionList = list.map(item=> {
                            return {
                                nftNo: item.elementId,
                                collectionName: '康养数字藏品',
                                image: item.url,
                                hash: item.hash,
                                collectionId: item.collectionId
                            }
                        })
                        Toast.show({
                            content: res.msg ?? '合成成功',
                            afterClose: () => {
                                const url = '/ape/PaySuccess'
                                navigate(url, { 
                                    state: {
                                        collectionList: collectionList, 
                                        from: CodeMap[detailList?.collectionId || ''],
                                        title: '合成成功',
                                        showNav: 1,
                                    }
                                });
                            }
                        });
                    }else {
                        Toast.show(res.msg);
                    }
                }else {
                    ModalAlert.hide();
                }
               
            },
            actions: [
                { key: 'cancel', text: '取消' },
                { key: 'confirm', text: '确认' }
            ]
        })
    }

    const giveAway = (navigateFlag) => {
        // if (!clickThrottle()){return}
        if (detailList?.transferStatus === 0) {
            if (!!detailList?.targetNftNo && !navigateFlag) { //有关联藏品
                setTargetNftNoModalVisible(true);
            } else {
                zhuanZenPwdJudgeClick();
            }
        } else if (detailList?.transferStatus === 1) {
            getReduceTimeCard();
        } else {
            setModalVisible(true);
        }
    }
    const toBenefitForPad = () => {
        const navUrl = `/nftPad/benefitGet?nftNo=${detailList?.nftNo}&targetId=${detailList?.collectionId}&targetType=1`
        if(window.JsBridge.hasWebViewBridge()) {
            window.JsBridge.replace("CustomWeb", {uri: `${window.location.origin}${navUrl}`});
        }else {
            navigate(navUrl);
        }
    }
    const toCulturalBenefit = () => {
        if(benefitList?.length > 0) {
            toBenefitForPad()
        } else {
            const navUrl = `/culturalExchange/getGuardsBenefit?nftNo=${detailList?.nftNo}&activityCode=${activityCode}`
            if(window.JsBridge.hasWebViewBridge()) {
                window.JsBridge.replace("CustomWeb", {uri: `${window.location.origin}${navUrl}`});
            }else {
                navigate(navUrl);
            }
        }
    }

    const handleBlessingConfirm = async () => {
        // 确认赠送：未过期则用 detailList 的分享字段，过期则调 addShareRecord 再分享
        if (window.JsBridge && window.JsBridge.hasWebViewBridge()) {
            let shareRecordId;
            let expireTime;
            let imageBg;
            let createdThisSession = false;

            try {
                const listExpireTime = detailList?.shareRecordResp?.expireTime;
                const now = Date.now();
                let listExpireMs = 0;
                if (listExpireTime != null) {
                    if (typeof listExpireTime === 'number') {
                        listExpireMs = listExpireTime > 1e12 ? listExpireTime : listExpireTime * 1000;
                    } else {
                        const str = typeof listExpireTime === 'string' ? decodeURIComponent(listExpireTime) : String(listExpireTime);
                        listExpireMs = new Date(str).getTime();
                    }
                }
                // 没有 expireTime、或已过期、或没有 shareRecordId 时，直接走 addShareRecord
                const notExpired = listExpireTime != null && !Number.isNaN(listExpireMs) && listExpireMs > now && detailList?.shareRecordResp?.shareRecordId;

                if (notExpired) {
                    shareRecordId = detailList.shareRecordResp.shareRecordId;
                    expireTime = detailList.shareRecordResp.expireTime;
                    imageBg = detailList.shareRecordResp.imageBg;
                } else {
                    showLoading();
                    const param2 = {
                        shareType: 'horseYear',
                        nftNo: detailList?.nftNo || '',
                        collectionId: detailList?.collectionId || '',
                    };
                    const res = await addShareRecord(param2);
                    hideLoading();
                    if (res.code !== '000000') throw res.msg || '分享记录创建失败';
                    const data = res.data || {};
                    shareRecordId = data.shareRecordId;
                    expireTime = data.expireTime;
                    imageBg = data.imageBg;
                    createdThisSession = true;
                }

                const param = `shareRecordId=${shareRecordId}&expireTime=${encodeURIComponent(expireTime || '')}&imageBg=${encodeURIComponent(imageBg || '')}`;
                const shareToast = Toast.show({ maskClickable: false, content: "分享中..." });
                const shareTitle = `绿地G优祝您${selectedBlessing}`;
                const shareText = `您的朋友给您赠送了一款马年新春数字藏品，快来领取吧`;
                const shareIcon = detailList?.nftImage || '';
                const shareLink = `${process.env.REACT_APP_GKT_LINK}/front/activities/fragmentsSyntheticMa/login?${param}`;

                try {
                    window.localStorage.setItem(WECHAT_SHARE_PENDING_KEY, JSON.stringify({ shareRecordId, createdThisSession }));
                } catch (e) {}

                window.JsBridge.share({
                    text: shareText,
                    icon: shareIcon,
                    link: shareLink,
                    title: shareTitle,
                    platform: 1, // 1=微信好友
                }).then(async function (result) {
                    try {
                        window.localStorage.removeItem(WECHAT_SHARE_PENDING_KEY);
                    } catch (e) {}
                    shareToast && shareToast.close();
                    setBlessingModalVisible(false);
                    // const cancelled = result && (result.cancelled === true || result.success === false);
                    // if (cancelled && createdThisSession) {
                    //     try {
                    //         await deleteShareRecord({ shareRecordId });
                    //     } catch (e) {}
                    //     Toast.show('已取消分享');
                    //     return;
                    // }
                    // if (cancelled) {
                    //     Toast.show('已取消分享');
                    //     return;
                    // }
                    // if (result && result.message) {
                    //     Toast.show(result.message);
                    // }
                    try {
                        window.localStorage.setItem('myCollectionNeedRefresh', '1');
                    } catch (e) {}
                    if (window.JsBridge.hasWebViewBridge()) {
                        window.JsBridge.back();
                    } else {
                        navigate(-1);
                    }
                }).catch(async function (error) {
                    try {
                        window.localStorage.removeItem(WECHAT_SHARE_PENDING_KEY);
                    } catch (e) {}
                    shareToast && shareToast.close();
                    setBlessingModalVisible(false);
                    if (createdThisSession) {
                        try {
                            await deleteShareRecord({ shareRecordId });
                        } catch (e) {}
                    }
                    Toast.show('分享失败，请重试');
                });
            } catch (error) {
                hideLoading();
                setBlessingModalVisible(false);
                Toast.show(error || '分享记录创建失败，请重试');
            }
        } else {
            setBlessingModalVisible(false);
            Toast.show('请在App中打开此页面进行分享');
        }
    }

    // const handleBlessingConfirm = async () => {
    //     // 确认赠送后先调用新增分享记录接口，再调用微信分享
    //     if (window.JsBridge && window.JsBridge.hasWebViewBridge()) {
    //         try {
    //             showLoading();
    //             const param2 ={
    //                 shareType: 'horseYear',
    //                 nftNo: detailList?.nftNo || '',
    //                 collectionId: detailList?.collectionId || '',
    //             }
    //             console.log("1111111111===>",param2);
    //             const res = await addShareRecord(param2);
    //             hideLoading();
    //             console.log("2222222===>",res);
    //             if (res.code !== '000000') throw res.msg || '分享记录创建失败';
    //             const { shareRecordId, expireTime,imageBg} = res.data || {};
    //             const param = `shareRecordId=${shareRecordId}&expireTime=${encodeURIComponent(expireTime || '')}&imageBg=${encodeURIComponent(imageBg || '')}`;
    //             const shareToast = Toast.show({ maskClickable: false, content: "分享中..." });
    //             const shareTitle = `绿地G优祝您${selectedBlessing}`;
    //             const shareText = `您的朋友给您赠送了一款马年新春数字藏品，快来领取吧`;
    //             const shareIcon = detailList?.nftImage || '';
    //             const shareLink = `${process.env.REACT_APP_GKT_LINK}/front/activities/fragmentsSyntheticMa/login?${param}`;

    //             window.JsBridge.share({
    //                 text: shareText,
    //                 icon: shareIcon,
    //                 link: shareLink,
    //                 title: shareTitle,
    //                 platform: 1, // 1=微信好友
    //             }).then(async function (result) {
    //                 shareToast && shareToast.close();
    //                 setBlessingModalVisible(false);
    //                 // 用户未选好友直接返回：原生可能 resolve 取消状态，走不到 catch，这里统一删记录
    //                 const cancelled = result && (result.cancelled === true || result.success === false);
    //                 if (cancelled) {
    //                     try {
    //                         await deleteShareRecord({ shareRecordId });
    //                     } catch (e) {}
    //                     Toast.show('已取消分享');
    //                     return;
    //                 }
    //                 if (result && result.message) {
    //                     Toast.show(result.message);
    //                 }
    //                 try {
    //                     window.localStorage.setItem('myCollectionNeedRefresh', '1');
    //                 } catch (e) {}
    //                 if (window.JsBridge.hasWebViewBridge()) {
    //                     window.JsBridge.back();
    //                 } else {
    //                     navigate(-1);
    //                 }
    //             }).catch(async function (error) {
    //                 shareToast && shareToast.close();
    //                 setBlessingModalVisible(false);
    //                 try {
    //                     await deleteShareRecord({ shareRecordId });
    //                 } catch (e) {}
    //                 Toast.show('分享失败，请重试');
    //             });
    //         } catch (error) {
    //             hideLoading();
    //             setBlessingModalVisible(false);
    //             Toast.show(error || '分享记录创建失败，请重试');
    //         }
    //     } else {
    //         setBlessingModalVisible(false);
    //         Toast.show('请在App中打开此页面进行分享');
    //     }
    // }

    const zhuanZenPwdJudgeClick = async () => { //转赠
        //有无设置过支付密码
        try {
            showLoading();
            const res = await getUserCollectionsSetting({});
            hideLoading();
            const {code, msg, data} = res;
            if (code !== '000000') throw msg;
            const {isHasPassword} = data;
            if (isHasPassword) {
                zhuanZenClick();
            } else { //没有设置过密码
                setPwdVisible(true);
            }
        } catch (error) {
            hideLoading();
            Toast.show(error);
        }
    }

    const zhuanZenClick = () => {
        let navUrl = `/donationInfo?nftNo=${detailList?.nftNo}&nftImage=${detailList?.nftImage}&targetNftNo=${detailList?.targetNftNo}&gemsCount=${gemsCount}&gemsFee=${gemsFee}`
        if (!!detailList?.imageDetailList && Array.isArray(detailList?.imageDetailList)) {
            navUrl += `&imageDetailList=${JSON.stringify(detailList?.imageDetailList)}`
        }
        if(window.JsBridge.hasWebViewBridge()) {
            window.JsBridge.replace("CustomWeb", {uri: `${window.location.origin}${navUrl}`});
        }else {
            navigate(navUrl);
        }

    }

    const onCloseCardModal = () => {
        setCardVisible(false);
        setChooseArr([]);
    }

    const useCard = async () => {
        try {
            showLoading();
            const params = {
                nftNo: detailList?.nftNo || '',
                collectionId: detailList?.collectionId || '',
                timeReduceCardInfoList: chooseArr,
            };
            const usedRes = await remainTimeCardUse(params);
            hideLoading();
            if (usedRes.code === '000000') {
                Toast.show(usedRes.msg);
                onRefesh && onRefesh();
                onCloseCardModal();
            } else if (usedRes.code === '510016') {
                onCloseCardModal();
                Toast.show(usedRes.msg);
            } else {
                throw usedRes.msg;
            }
        } catch (error) {
            Toast.show(error);
        }
    }

    const onChooseCard = (item) => {
        const arr = [...chooseArr];
        const index = arr.findIndex((i) => i.timeReduceId === item.timeReduceId);
        if (index >= 0) {
            arr.splice(index, 1);
        } else {
            arr.push(item);
        }
        if (Number(item.accumulateDays) === 30) {
            if (arr.length > limitNum(detailList?.remainDays)) {
                Toast.show(`超出剩余转赠天数`);
                return;
            }
        } else {
            const num = arr.reduce((pre, curr) => {
                return pre += curr.reduceDay;
            }, 0);
            if (num > (detailList?.remainDays < (Number(list[0]?.accumulateDays) - Number(usedDays)) ? limitNum(detailList?.remainDays) * list[0]?.reduceDay : (Number(list[0]?.accumulateDays) - Number(usedDays)))) {
                const text = detailList?.remainDays < (Number(list[0]?.accumulateDays) - Number(usedDays)) ? '超出剩余转赠天数' : `单个藏品最多减${item.accumulateDays}天`;
                Toast.show(text);
                return;
            }
        }
        setChooseArr(arr);
    }

    //是否展示孵蛋按钮
    const isShowFD = useMemo(()=>{
        let isShowFD = false;
        if (detailList && detailList?.collectionGroup) {
            isShowFD = true;
        }
    
        let collectionId = parseInt(detailList?.collectionId) || 0;
        if (collectionId === 9) {
            isShowFD = true;
        } else { //已经合成过了
            isShowFD = false;
        }
        return isShowFD;
    },[detailList])

    const BtnBox = {
        0: {style: 'can-donation-bg', text: '转赠'},
        1: {style: 'notdonation-bg', text: `${detailList?.remainDays}天后可转赠`},
        2: {style: 'donation-bg', text: '等待接收'},
        4: {style: 'land-ape', text: ''},
    }

    const modalContentMap = {
        1: {
            title: '未满足持有天数',
            content: `藏品自持有日起，需持有满${detailList?.transferMinimumDays}天后才可以转赠。${getTime(detailList?.collectTime, detailList?.transferMinimumDays)} 之后可以转赠，该藏品不限制转赠次数。`
        },
        2: {title: '等待接收', content: `该藏品已提交转赠流程，等待好友接收。`},
    }
    
    return (
        <div className="detail_footer">
            {/*{
                detailList?.remainDays > 0 &&
                <div className="reduce-time" onClick={() => getReduceTimeCard()}>
                    <img src={reduceImg} alt="" />
                    <span>使用减时卡</span>
                </div>
            }*/}
            {
                spHeChengInfo?.canSynthesize ? 
                <div className="reduce-time"
                    onClick={() => setColCompHomeVisible(!colCompHomeVisible)}
                >
                    <img src={imgSynthesis} alt="" />
                    <span>藏品合成</span>
                </div> 
                : null
            }
            {
                isShowFD ? 
                <div className={classNames('hecheng_btn',{'enable': hcStatus.status === 1})}
                    onClick={() => hcClick()}> 孵化合成</div> 
                : null
            }
            {
                hcStatus.status === 1 && detailList?.collectionId === 207 ?
                <>
                {
                    hcStatus.count >= hcStatus.requireCount?
                    <div className={classNames('hecheng_btn','enable')} 
                        onClick={onKangyangMerge}> 合成</div> :
                    <div className={classNames('hecheng_btn')}> 
                        合成<br/> <span>{`(未满${hcStatus.requireCount ?? '--'}个)`}</span>
                    </div>
                }
                </>
                :null
            }
            
            {
                [78, 79, 80, 81].includes(detailList?.collectionId) ? 
                <div
                    className={classNames('use_beautiful_num', {'re_submit': detailList?.useStatus === 3})}
                    onClick={onUseBeautifulNumBtn}
                >
                    {BeautifulNumBtnText[detailList?.useStatus]}
                </div> 
                : null
            }
            {
                detailList?.transferStatus !== 4&&(detailList?.collectionId<314||detailList?.collectionId>340) &&
                <div onClick={giveAway}
                    className={classNames('give_away', BtnBox[detailList?.transferStatus]?.style)}
                >
                    {BtnBox[detailList?.transferStatus]?.text}
                </div>
            }
            {
             (detailList?.collectionId<314||detailList?.collectionId>338) && detailList?.avail === 1 &&
              <div onClick={toCulturalBenefit}
                   className={classNames('give_away', 'can-donation-bg')}
              >
                  查看/领取权益
              </div>
            }

            {
            detailList?.transferStatus !== 4 && detailList?.collectionId>313&&detailList?.collectionId<341 ?
              <div onClick={giveAway}
                   className={classNames('give_away2')}
              >
                  <div className={classNames('give_away2_text', 'can-donation-bg')}>转赠</div>
              </div>:null
            }

            {
            detailList?.collectionId>313&&detailList?.collectionId<339?
              <div onClick={() => setBlessingModalVisible(true)}
                   className={classNames('give_away', 'can-donation-bg')}
              >
                  给好友送祝福
              </div>:null
            }
            {/* <div onClick={() => setBlessingModalVisible(true)}
                   className={classNames('give_away', 'can-donation-bg')}
              >
                  给好友送祝福
              </div> */}

            {/* 减时卡弹框 */}
            <ReduceCard
                visible={cardVisible}
                onClose={onCloseCardModal}
                onChooseCard={onChooseCard}
                reduceDays={reduceDays}
                chooseArr={chooseArr}
                list={list}
                onConfirmUse={()=>setCardModalVisible(true)}
                remainDays={detailList?.remainDays}
            />
            <DonationModal
                subTitle={'与该藏品绑定的共创形象将会一同转赠\n确定进行转赠吗？'}
                visible={!!targetNftNoModalVisible}
                onClose={() => setTargetNftNoModalVisible(false)}
                leftBtnText="取消"
                rightBtnText="确认转赠"
                rightBtnCB={() => {
                    giveAway(true)
                }}
            />
            <DonationModal
                title={modalContentMap[detailList?.transferStatus]?.title}
                content={modalContentMap[detailList?.transferStatus]?.content}
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
            />
            {/* 确认弹框 */}
            <DonationModal
                title="使用减时卡确认"
                content={`确认使用${chooseArr.length}张减时卡？`}
                visible={cardModalVisible}
                onClose={() => setCardModalVisible(false)}
                leftBtnText="取消"
                rightBtnText="使用"
                rightBtnCB={useCard}
            />
            <DonationModal
                title="友情提示"
                content={`为了您的资产安全，请先设置交易密码`}
                visible={pwdVisible}
                onClose={() => setPwdVisible(false)}
                leftBtnText="取消"
                rightBtnText="去设置"
                rightBtnCB={() => {
                    window.JsBridge.push('Web', {uri: `${window.location.origin}/pwdSetting`})
                }}
            />
            {
                colCompHomeVisible ?
                <ColCompoundHome maskVisible={colCompHomeVisible} 
                    setMaskVisible={setColCompHomeVisible} 
                    spHeChengInfo={spHeChengInfo}
                /> : null
            }
            {/* 祝福语选择弹窗 */}
            {blessingModalVisible && (
                <div className="blessing-modal" onClick={() => setBlessingModalVisible(false)}>
                    <div className="blessing-modal-container" onClick={(e) => e.stopPropagation()}>
                        <div className="blessing-modal-title">请选择祝福语</div>
                        <div className="blessing-modal-greeting">祝您新的一年</div>
                        <div className="blessing-options">
                            <div
                                className={classNames('blessing-option', { 'selected': selectedBlessing === '马到成功' })}
                                onClick={() => setSelectedBlessing('马到成功')}
                            >
                                马到成功
                            </div>
                            <div
                                className={classNames('blessing-option', { 'selected': selectedBlessing === '龙马精神' })}
                                onClick={() => setSelectedBlessing('龙马精神')}
                            >
                                龙马精神
                            </div>
                            <div
                                className={classNames('blessing-option', { 'selected': selectedBlessing === '阖家安康' })}
                                onClick={() => setSelectedBlessing('阖家安康')}
                            >
                                阖家安康
                            </div>
                            <div
                                className={classNames('blessing-option', { 'selected': selectedBlessing === '万事顺遂' })}
                                onClick={() => setSelectedBlessing('万事顺遂')}
                            >
                                万事顺遂
                            </div>
                            <div
                                className={classNames('blessing-option', { 'selected': selectedBlessing === '财源广进' })}
                                onClick={() => setSelectedBlessing('财源广进')}
                            >
                                财源广进
                            </div>
                        </div>
                        <div className="blessing-confirm-btn" onClick={handleBlessingConfirm}>
                            确认赠送
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export {
    Footer
}